/* Replica test page behaviours. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  /* Auto-scrolling strips (quote ticker, before/after). The first child is cloned until the strip is 2x the viewport,
     then the track slides left by exactly one group width per loop. Speed in px/s from data-speed. */
  function marquee(track) {
    var group = track.firstElementChild;
    if (!group) return;
    var speed = parseFloat(track.getAttribute('data-speed')) || 50;
    function build() {
      $$('[data-clone]', track).forEach(function (n) { n.remove(); });
      var w = group.getBoundingClientRect().width;
      if (!w) return;
      var need = Math.ceil((window.innerWidth * 2) / w) + 1;
      for (var i = 0; i < need; i++) {
        var c = group.cloneNode(true);
        c.setAttribute('data-clone', '');
        c.setAttribute('aria-hidden', 'true');
        $$('a,button', c).forEach(function (el) { el.setAttribute('tabindex', '-1'); });
        track.appendChild(c);
      }
      track.style.setProperty('--rp-mq-dist', w + 'px');
      if (!reduce) track.style.animation = 'rp-marquee ' + (w / speed).toFixed(2) + 's linear infinite';
    }
    build();
    var lastW = window.innerWidth;
    window.addEventListener('resize', debounce(function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; build(); } }, 200));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
    window.addEventListener('load', build);
  }

  /* Gallery: snap track + thumbs + arrows. */
  function gallery(root) {
    var track = $('[data-track]', root), thumbs = $$('.rp-gal__thumb', root), strip = $('[data-thumbs]', root);
    var slides = $$('.rp-gal__slide', track);
    if (!slides.length) return;
    var current = 0;
    function go(i, smooth) {
      var n = slides.length;
      i = (i + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    function setActive(i) {
      if (i === current && thumbs[i] && thumbs[i].classList.contains('is-active')) return;
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var t = thumbs[i];
      if (t && strip) strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
    }
    track.addEventListener('scroll', debounce(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, 60), { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    root.rpGo = go;
  }

  /* Generic carousel: [data-track] of cards, optional [data-dots], [data-prev], [data-next]. One dot per card. */
  function carousel(root) {
    var track = $('[data-track]', root);
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    var dotsWrap = $('[data-dots]', root);
    var dots = [];
    function step() { if (cards.length < 2) return track.clientWidth; return cards[1].offsetLeft - cards[0].offsetLeft; }
    function index() {
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= max - 4) return cards.length - 1;
      return Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step())));
    }
    function to(i) { track.scrollTo({ left: Math.max(0, i) * step(), behavior: 'smooth' }); }
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (cards.length > 1 && maxScroll > 4) {
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', function () { to(i); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      } else {
        dotsWrap.style.display = 'none';
      }
    }
    function sync() { var i = index(); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); }
    track.addEventListener('scroll', debounce(sync, 40), { passive: true });
    sync();
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (prev) prev.addEventListener('click', function () { var i = index(); to(i <= 0 ? cards.length - 1 : i - 1); });
    if (next) next.addEventListener('click', function () { var i = index(); var max = track.scrollWidth - track.clientWidth; to(track.scrollLeft >= max - 4 ? 0 : i + 1); });
  }

  /* Paged tracks (ingredients): arrows scroll the visible track by one page. */
  function pager(panel) {
    function visibleTrack() { return $$('[data-rp-pager]', panel).filter(function (t) { return t.offsetParent !== null; })[0]; }
    var prev = $('[data-pager-prev]', panel), next = $('[data-pager-next]', panel);
    function move(dir) {
      var t = visibleTrack();
      if (!t) return;
      var max = t.scrollWidth - t.clientWidth;
      var target = t.scrollLeft + dir * t.clientWidth;
      if (target > max + 4) target = 0;
      if (target < -4) target = max;
      t.scrollTo({ left: target, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    /* No arrows when everything already fits (e.g. one full page on desktop). */
    function check() { var t = visibleTrack(); panel.classList.toggle('is-static', !!t && t.scrollWidth <= t.clientWidth + 2); }
    check();
    window.addEventListener('resize', debounce(check, 150));
    window.addEventListener('load', check);
  }

  /* Accordions: the first button child toggles the .rp-acc__body sibling. */
  function accordion(item) {
    var btn = item.querySelector('button');
    var body = item.querySelector('.rp-acc__body');
    if (!btn || !body) return;
    btn.addEventListener('click', function () {
      var open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) body.removeAttribute('hidden'); else body.setAttribute('hidden', '');
    });
  }

  /* Tabbed card. */
  function tabs(root) {
    var btns = $$('[data-tab]', root), panels = $$('[data-panel]', root);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-tab');
        btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { if (p.getAttribute('data-panel') === k) p.removeAttribute('hidden'); else p.setAttribute('hidden', ''); });
      });
    });
  }

  /* Weekly timeline: stage text + chart line drawn up to the stage's week. */
  function weeks(root) {
    var btns = $$('.rp-wk__tab', root);
    var svg = $('.rp-chart', root);
    var vals = (svg && svg.getAttribute('data-values') || '').split(',').map(parseFloat).filter(function (v) { return !isNaN(v); });
    var ymin = parseFloat(svg && svg.getAttribute('data-ymin')) || 0, ymax = parseFloat(svg && svg.getAttribute('data-ymax')) || 10;
    var g = svg && svg.querySelector('[data-data]');
    var NS = 'http://www.w3.org/2000/svg';
    function x(w) { return 37.8 + (w - 1) * 42.4; }
    function y(v) { return 225.9 - (v - ymin) / (ymax - ymin) * (225.9 - 24.2); }
    function draw(upto) {
      if (!g) return;
      while (g.firstChild) g.removeChild(g.firstChild);
      var pts = [];
      for (var w = 1; w <= Math.min(upto, vals.length); w++) pts.push([x(w), y(vals[w - 1])]);
      if (pts.length > 1) {
        var pl = document.createElementNS(NS, 'polyline');
        pl.setAttribute('points', pts.map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' '));
        pl.setAttribute('class', 'rp-chart__line');
        g.appendChild(pl);
      }
      pts.forEach(function (p) {
        var c = document.createElementNS(NS, 'circle');
        c.setAttribute('cx', p[0].toFixed(1)); c.setAttribute('cy', p[1].toFixed(1)); c.setAttribute('r', '5.8');
        c.setAttribute('class', 'rp-chart__dot');
        g.appendChild(c);
      });
    }
    function show(b) {
      var k = b.getAttribute('data-stage');
      btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
      $$('.rp-wk__stage, .rp-wk__list', root).forEach(function (el) { if (el.getAttribute('data-stage') === k) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); });
      draw(parseInt(b.getAttribute('data-upto'), 10) || 1);
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { show(b); }); });
    if (btns[0]) show(btns[0]);
  }

  /* "View more" lists. */
  function more(btn) {
    var sec = btn.closest('section') || document;
    var list = $('[data-rp-more]', sec);
    if (!list) return;
    var moreText = btn.textContent, lessText = btn.getAttribute('data-less') || moreText;
    var open = false;
    btn.addEventListener('click', function () {
      open = !open;
      $$('.is-extra', list).forEach(function (el) { if (open) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); });
      btn.textContent = open ? lessText : moreText;
    });
  }

  /* Video cards: play inline with sound, one at a time; fullscreen button. */
  function videos() {
    var cards = $$('[data-rp-video]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function stopAll(except) {
      cards.forEach(function (c) { if (c === except || c.classList.contains('rp-vidc--auto')) return; var v = $('video', c); if (v && !v.paused) v.pause(); c.classList.remove('is-playing'); });
    }
    function play(c, v, muted) {
      v.muted = muted;
      c.classList.add('is-playing');
      var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
    }
    function fullscreen(c, v) {
      stopAll(c); play(c, v, false);
      if (v.requestFullscreen) v.requestFullscreen(); else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen(); else if (v.webkitRequestFullscreen) v.webkitRequestFullscreen();
    }
    var auto = [];
    cards.forEach(function (c) {
      var v = $('video', c), btn = $('.rp-vidc__play', c), full = $('.rp-vidc__full', c);
      if (!v) { if (btn) btn.disabled = true; return; }
      v.removeAttribute('controls');
      if (btn) btn.addEventListener('click', function () { stopAll(c); play(c, v, false); });
      if (full) full.addEventListener('click', function () { fullscreen(c, v); });
      if (c.classList.contains('rp-vidc--auto')) {
        auto.push(c);
        c.addEventListener('click', function (e) { if (!e.target.closest('.rp-vidc__full')) fullscreen(c, v); });
        document.addEventListener('fullscreenchange', function () { if (!document.fullscreenElement) v.muted = true; });
        v.addEventListener('webkitendfullscreen', function () { v.muted = true; });
      } else {
        v.addEventListener('click', function () { if (v.paused) { stopAll(c); play(c, v, false); } else { v.pause(); c.classList.remove('is-playing'); } });
      }
    });
    // Silent looping previews: play while at least 60% of the card is on screen, pause when it leaves.
    if (auto.length && !reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var c = en.target, v = $('video', c);
          if (en.isIntersecting && en.intersectionRatio >= 0.6) play(c, v, true);
          else if (!v.paused && !document.fullscreenElement) v.pause();
        });
      }, { threshold: [0, 0.6] });
      auto.forEach(function (c) { io.observe(c); });
    }
  }

  /* Bundle selector: one card per bundle. Selecting one updates the price row, the % badge, the gift line,
     locks gift tiles that need more pouches, the sticky bar text and every [data-rp-buy] link (straight to checkout). */
  function tiers() {
    var cards = $$('[data-rp-tier]');
    if (!cards.length) return;
    var now = $('[data-rp-price-now]'), was = $('[data-rp-price-was]'), badge = $('[data-rp-badge]'), off = $('[data-rp-off]'), gl = $('[data-rp-giftline]');
    function select(card, focus) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });
      var d = card.dataset;
      window.rpCheckout = d.permalink;
      $$('[data-rp-buy]').forEach(function (a) { a.href = d.permalink; });
      if (now && d.price) { var p = d.price.split('.'); now.innerHTML = p[0] + (p[1] ? '<sup>.' + p[1] + '</sup>' : ''); }
      if (was) { was.textContent = d.compare || ''; if (d.compare) was.removeAttribute('hidden'); else was.setAttribute('hidden', ''); }
      if (badge && badge.getAttribute('data-mode') !== 'save') { if (+d.off > 0) badge.removeAttribute('hidden'); else badge.setAttribute('hidden', ''); }
      if (d.save) $$('[data-rp-save]').forEach(function (el) { el.textContent = d.save; });
      if (d.savePct) $$('[data-rp-save-pct]').forEach(function (el) { el.textContent = d.savePct; });
      if (off) off.textContent = d.off;
      if (gl && d.giftline) gl.textContent = d.giftline;
      if (d.cta) $$('[data-rp-cta-txt]').forEach(function (el) { if (!el.closest('[data-rp-buy-pouches]')) el.textContent = d.cta; });
      if (d.kitTotal) $$('[data-rp-kit-total]').forEach(function (el) { el.textContent = d.kitTotal; });
      if (d.pp) $$('[data-rp-lock-pp]').forEach(function (el) { el.textContent = d.pp; });
      if (d.units) $$('[data-rp-lock-units]').forEach(function (el) { el.textContent = d.units; });
      $$('[data-rp-sticky-name]').forEach(function (el) { el.textContent = d.stickyName || d.sticky; });
      $$('[data-rp-sticky-price]').forEach(function (el) { el.textContent = d.stickyPrice || ''; });
      var n = parseInt(d.pouches, 10) || 1;
      $$('[data-rp-min]').forEach(function (t) { t.classList.toggle('is-locked', n < (parseInt(t.getAttribute('data-rp-min'), 10) || 1)); });
      if (focus) card.focus();
    }
    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { select(c); });
      c.addEventListener('keydown', function (e) {
        var j = -1;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') j = (i + 1) % cards.length;
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') j = (i - 1 + cards.length) % cards.length;
        if (j > -1) { e.preventDefault(); select(cards[j], true); }
      });
    });
    select(cards.filter(function (c) { return c.classList.contains('is-selected'); })[0] || cards[0]);
    /* Buttons that always sell one fixed bundle (value stack): link and text come from that bundle. */
    $$('[data-rp-buy-pouches]').forEach(function (a) {
      var c = cards.filter(function (x) { return x.dataset.pouches === a.getAttribute('data-rp-buy-pouches'); })[0];
      if (!c) return;
      a.href = c.dataset.permalink;
      var t = $('[data-rp-cta-txt]', a);
      if (t && c.dataset.cta) t.textContent = c.dataset.cta;
    });
    /* Locked gifts: tapping the row (or its "Unlock with N pouches" button) selects the smallest bundle that unlocks it. */
    $$('[data-rp-unlock]').forEach(function (b) {
      var row = b.closest('.rp-gstack__row');
      (row || b).addEventListener('click', function () {
        if (row && !row.classList.contains('is-locked')) return;
        var need = parseInt(b.getAttribute('data-rp-unlock'), 10) || 1;
        var c = cards.filter(function (x) { return (parseInt(x.dataset.pouches, 10) || 1) >= need; })
          .sort(function (x, y) { return x.dataset.pouches - y.dataset.pouches; })[0];
        if (c) select(c);
      });
    });
  }

  /* Sticky buy bar: visible once the hero buy button has scrolled above the viewport. */
  function sticky() {
    var bar = $('[data-rp-sticky]'), anchor = $('.rp-cta--hero') || $('[data-rp-hero]');
    if (!bar || !anchor) return;
    var links = $$('a', bar), ticking = false;
    function check() {
      ticking = false;
      var on = anchor.getBoundingClientRect().bottom < 0;
      if (on !== bar.classList.contains('is-visible')) {
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        links.forEach(function (l) { l.setAttribute('tabindex', on ? '0' : '-1'); });
        document.documentElement.classList.toggle('rp-has-sticky', on);
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', debounce(check, 150));
    check();
  }

  /* "Order within Xh Ym" until local midnight, and the arrival date (today + N days). */
  function clocks() {
    var cd = $$('[data-rp-countdown]');
    function tick() {
      var now = new Date(), end = new Date(now); end.setHours(23, 59, 59, 999);
      var mins = Math.max(0, Math.floor((end - now) / 60000));
      var txt = Math.floor(mins / 60) + 'h ' + ('0' + (mins % 60)).slice(-2) + 'm';
      cd.forEach(function (el) { el.textContent = txt; });
    }
    if (cd.length) { tick(); setInterval(tick, 30000); }
    $$('[data-rp-arrive]').forEach(function (el) {
      var d = new Date(); d.setDate(d.getDate() + (parseInt(el.getAttribute('data-days'), 10) || 7));
      el.textContent = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).toUpperCase();
    });
  }

  /* Mobile menu. */
  function menu() {
    var m = $('[data-rp-menu]'), open = $('[data-rp-menu-open]');
    if (!m || !open) return;
    function set(on) {
      if (on) m.removeAttribute('hidden'); else m.setAttribute('hidden', '');
      open.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.documentElement.style.overflow = on ? 'hidden' : '';
    }
    open.addEventListener('click', function () { set(true); });
    $$('[data-rp-menu-close]', m).forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    m.addEventListener('click', function (e) { if (e.target === m) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* The sticky header hides the offer bar by the bar's own height (--rp-offer-h). The bar grows when its copy
     wraps to two lines on phones, so measure it on load, after the fonts arrive and on resize. */
  function offerBar() {
    var bar = $('.rp-offer');
    if (!bar) return;
    function set() { document.documentElement.style.setProperty('--rp-offer-h', bar.offsetHeight + 'px'); }
    set();
    window.addEventListener('resize', debounce(set, 100));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
  }

  function init() {
    $$('[data-rp-marquee]').forEach(marquee);
    $$('[data-rp-gallery]').forEach(gallery);
    $$('[data-rp-carousel]').forEach(carousel);
    $$('.rp-ing__panel').forEach(pager);
    $$('[data-rp-acc]').forEach(accordion);
    $$('[data-rp-tabs]').forEach(tabs);
    $$('[data-rp-weeks]').forEach(weeks);
    $$('[data-rp-more-btn]').forEach(more);
    videos();
    tiers();
    sticky();
    clocks();
    menu();
    offerBar();
    /* Supplement facts links jump the gallery to that slide and bring it into view. */
    $$('[data-rp-facts]').forEach(function (b) {
      b.addEventListener('click', function () {
        var gal = $('[data-rp-gallery]');
        if (!gal || !gal.rpGo) return;
        gal.rpGo(parseInt(b.getAttribute('data-rp-facts'), 10) || 0);
        var top = gal.getBoundingClientRect().top + window.pageYOffset - 70;
        if (gal.getBoundingClientRect().top < 60) window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
    var w = $('[data-rp-write]');
    if (w) w.addEventListener('click', function () { var n = w.nextElementSibling; if (n) n.removeAttribute('hidden'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
